import { Service, service } from './di'

type ICache = { [key: string]: string }
@service('storageService')
export class StorageService extends Service {
    cache: ICache = {}

    get available() {
        let ok = true
        try {
            localStorage.setItem('storageCheck', '')
            localStorage.removeItem('storageCheck')
        } catch (e) {
            ok = false
        }
        return ok
    }

    setItem(key: string, value: string) {
        try {
            localStorage.setItem(key, value)
            return true
        } catch (e) {
            console.error(`Error setting item in localeStorage: ${e.message}`)
            return false
        }
    }

    getItem(key: string): any {
        try {
            return localStorage.getItem(key)
        } catch (e) {
            console.error(`Error getting item from localeStorage: ${e.message}`)
            return undefined
        }
    }

    removeItem(key: string) {
        try {
            localStorage.removeItem(key)
        } catch (e) {
            console.error(
                `Error removing item from localeStorage: ${e.message}`
            )
        }
    }
}
